import React, { useEffect, useState } from 'react';

import { useHelpBundle } from '@plasma/ui.application.app';
import { useResourceBundle, useTranslation } from '@plasma/ui.utils.i18n';

import translations from './i18n';
import { AreaMasterProps } from './area-master';
import help from './area-master.help';

import { fetchAllDataGet_byApiName } from '../../services/gets/getdata';
import { sendAllDataPost_byApiNameAndData } from '../../services/posts/postdata';
import areaMasterColumns from '../../types/areaMasterDataType';
import notification from '@plasma/ui.feedback.notification';
import { deleteDataFromApiWithBody } from '../../services/Deletes/deleteData';
import { apiUriMasterDataHttp } from '../../services/conf/apiConf';

function useAreaMasterHook(props: AreaMasterProps) {
  useResourceBundle(translations, undefined, 'a7d30de9-5fe4-4b4a-ae2c-4eeac6c098a6');
  useHelpBundle(help);

  const { t } = useTranslation();

  const [dataForColumns, setdataForColumns] = useState([]);
  const [columnNames, setcolumnNames] = useState(areaMasterColumns());


  useEffect(() => {
    fetchAllDataGet_byApiName("GetMasterAreas", apiUriMasterDataHttp()).then((data) => {
      setdataForColumns(data);

    }).catch((error)=>{
      console.log("Failed to Fetch Areas");
    });
  },[]);


  const handleSaveAndDeleteFromTable = (data, returnType) =>{

    if(returnType === 'delete'){
      deleteDataFromApiWithBody('DeleteMasterArea', data, apiUriMasterDataHttp())
      .then((response) => {
        if(response){
          fetchAllDataGet_byApiName("GetMasterAreas", apiUriMasterDataHttp()).then((data) => {
            setdataForColumns(data);
            notification.success('Removed !', 'Data Deleted Permanently', undefined, 'medium', 3)
          }).catch((error)=>{
            console.log("Failed to EditPlantLayout");
          });
        }
      }).catch((error) => {
        console.log(error);
        notification.error('Error !', 'Unsuccessful Attempt', undefined, 'medium', 3)
      });
    }
    else{
      if(data.displayseq === ''){
      data.displayseq = 0;
      }

      data.displayseq = parseFloat(data.displayseq);

      if (data.isactive === '' ) {
        data.isactive = false ;
        }

      //console.log(data);

      sendAllDataPost_byApiNameAndData('AddMasterArea', data, apiUriMasterDataHttp())
        .then((response) => {
          if(response){
            fetchAllDataGet_byApiName("GetMasterAreas", apiUriMasterDataHttp()).then((data) => {
              setdataForColumns(data);
              notification.success('Success !', 'Data Saved Successfully', undefined, 'medium', 3)
            }).catch((error)=>{
              console.log("Failed to EditPlantLayout");
            });
          }
        }).catch((error) => {
          console.log(error);
          notification.error('Error !', 'Unsuccessful Attempt', undefined, 'medium', 3)
        });
    }

  };


  return {
    t,
    dataForColumns,
    columnNames,
    handleSaveAndDeleteFromTable
  };
}

export default useAreaMasterHook;
